/**
 * Constantes partagées des types de points de collecte.
 * Code couleur ALIGNÉ sur le calendrier de collecte existant (DechetsSection) :
 *   verre = success (vert), végétaux = urba, encombrants = info (bleu).
 * Ajouts : textile (violet), piles (rouge doux), huiles/DEEE (ambre), déchetterie (orange).
 * Les couleurs sont en oklch (mêmes tokens que globals.css) pour rester cohérent
 * partout (pastilles listes + marqueurs Leaflet).
 */

import type { CollecteType } from '@/lib/api';

export const COLLECTE_LABEL: Record<CollecteType, string> = {
  verre: 'Verre',
  textile: 'Textile',
  piles: 'Piles',
  vegetaux: 'Déchets verts / compost',
  encombrants: 'Encombrants',
  huiles_deee: 'Huiles / DEEE',
  dechetterie: 'Déchetterie',
  autre: 'Autre',
};

/** Couleur oklch par type (marqueur + pastille). */
export const COLLECTE_COLOR: Record<CollecteType, string> = {
  verre: 'oklch(0.60 0.18 155)',
  textile: 'oklch(0.62 0.16 300)',
  piles: 'oklch(0.62 0.14 20)',
  vegetaux: 'oklch(0.55 0.16 145)',
  encombrants: 'oklch(0.58 0.15 230)',
  huiles_deee: 'oklch(0.70 0.17 75)',
  dechetterie: 'oklch(0.68 0.14 45)',
  autre: 'oklch(0.55 0.012 260)',
};

/** Emoji indicatif par type (marqueur). */
export const COLLECTE_EMOJI: Record<CollecteType, string> = {
  verre: '🍾',
  textile: '👕',
  piles: '🔋',
  vegetaux: '🌿',
  encombrants: '🛋️',
  huiles_deee: '🛢️',
  dechetterie: '♻️',
  autre: '📍',
};

export const COLLECTE_TYPES: CollecteType[] = [
  'verre', 'textile', 'piles', 'vegetaux', 'encombrants', 'huiles_deee', 'dechetterie', 'autre',
];
